import { PayloadAction } from "@reduxjs/toolkit";

import { CarsState } from '../../types';

export const updateEBoxDashboardData = (
  state: CarsState,
  action: PayloadAction<CarsState['eBoxDashboardData']['data']>
) => {
  state.eBoxDashboardData.data = action.payload;
}
